// extracted by mini-css-extract-plugin
export default {"content":"WelcomeMessage_content__nL2Fm","title":"WelcomeMessage_title__hH-fy","subtitle":"WelcomeMessage_subtitle__YOMyb","description":"WelcomeMessage_description__czZs9"};